<template>
  <div class="g-page__row">
    <h3>{{ $t('createEnvelope.partySelectionConfirmation.yourSelectedParties') }}</h3>
    <!--TODO replace with cards-->
    <VPartiesSelected
      :parties="$store.state.envelopes.creating.envelope.parties"
    />
  </div>
</template>

<script>
import VPartiesSelected from '@/views/components/PartiesSelected.vue';

export default {
  name: 'VPartySelectionConfirmation',
  description: 'Wraps party-selection. Used to list parties you\'ve already selected',
  components: {
    VPartiesSelected,
  },
};
</script>

<style scoped>

</style>
